
export default {
  name: 'LayoutClaim',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    accentHeadline: { type: String, default: '' },
    darkBg: { type: Boolean, default: false },
  },
}
